import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EasFormControl } from '../easform';


@Component({
    selector: 'app-csv-input',
    templateUrl: './csv-input.component.html',
    styleUrls: ['./csv-input.component.css'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CSVInputComponent),
            multi: true
        }],
    standalone: false
})
export class CSVInputComponent implements ControlValueAccessor {

  @Input() easControl!: EasFormControl;

  inputText: string = '';

  private _onChange = (_: any) => {};
  private _onTouched = () => {};

  writeValue(values: string[]): void {
    console.log('writeValue called with:', values);  // Log to see the passed values
    if (Array.isArray(values)) {
      this.inputText = values.join(',');
    } else {
      this.inputText = '';
    }
}

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  onTextChange(text: string): void {
    // Split the input text by commas, trim whitespace, and remove quotes
    const values = text.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)?.map(val => val.trim().replace(/^"|"$/g, '')) || [];
    this._onChange(values);
    this._onTouched();
  }

  onBlur(): void {
    this._onTouched();
  }

}
